import { Controller } from "@hotwired/stimulus"

import { createFormHelpers } from "../../modules/admissoes/form_helpers"
import { initInitialState } from "../../modules/admissoes/initial_state"
import { initHorarioEscala } from "../../modules/admissoes/horario_escala"
import { initDependentesDocs } from "../../modules/admissoes/dependentes_docs"
import { initReservista } from "../../modules/admissoes/reservista"
import { initBeneficios } from "../../modules/admissoes/beneficios"
import { initCargoSalario } from "../../modules/admissoes/cargo_salario"
import { initDefaultsApi } from "../../modules/admissoes/defaults_api"
import { initAdiantamento } from "../../modules/admissoes/adiantamento"

// Controller: admissoes--form
export default class extends Controller {
  static values = {
    salariosUrl: String,
    defaultsUrl: String,
  }

  connect() {
    if (typeof window.$j === "undefined") return
    const $j = window.$j

    const $root = $j(this.element)
    const $form = $root.find("#new_movimentacoes_pessoal").first()
    if (!$form.length) return

    if ($form.data("admissao-initialized") === true) return
    $form.data("admissao-initialized", true)

    const helpers = createFormHelpers($j, $form)
    const api = {
      salariosUrl: this.salariosUrlValue,
      defaultsUrl: this.defaultsUrlValue,
    }

    // guarda módulos pra destruir no disconnect
    this._admissaoModules = []

    // 1) estado inicial (hide de campos + limpeza de textos)
    this._admissaoModules.push(initInitialState($form, helpers))

    // 2) features (cada uma liga seus events / apply / destroy)
    const horarioEscala = initHorarioEscala($form, helpers)
    const dependentes = initDependentesDocs($form, helpers)
    const reservista = initReservista($form, helpers)
    const beneficios = initBeneficios($form, helpers)
    const cargoSalario = initCargoSalario($j, $form, helpers, api)
    const adiantamento = initAdiantamento($form, helpers) // ✅ NOVO

    this._admissaoModules.push(
      horarioEscala,
      dependentes,
      reservista,
      beneficios,
      cargoSalario,
      adiantamento // ✅ NOVO
    )

    // 3) aplica estado coerente (1ª render)
    horarioEscala.apply()
    dependentes.apply()
    reservista.apply()
    beneficios.apply()
    if (adiantamento.apply) adiantamento.apply() // ✅ NOVO (se o módulo expõe apply)

    // 4) defaults da API (aplica e reaplica os estados)
    const defaults = initDefaultsApi($j, $form, helpers, api, {
      afterApply: () => {
        beneficios.apply()
        reservista.apply()
        dependentes.apply()
        horarioEscala.apply()
        if (adiantamento.apply) adiantamento.apply() // ✅ NOVO
      },
    })
    this._admissaoModules.push(defaults)
  }

  disconnect() {
    if (typeof window.$j === "undefined") return
    const $j = window.$j
    const $form = $j(this.element).find("#new_movimentacoes_pessoal").first()
    if (!$form.length) return

      ; (this._admissaoModules || []).forEach((m) => {
        try {
          if (m && typeof m.destroy === "function") m.destroy()
        } catch (_e) { }
      })

    this._admissaoModules = []
  }
}
